// @ts-ignore
import { Dispatcher } from 'flux';

export default new Dispatcher();

export interface DispatcheEvent {
  type: string;
  value: any;
}
